export class BaseModel {
	id: number;
	createdAt: string;
	updatedAt: string;
}
